import { CustomAlert } from "components";
import { useEffect } from "react";
import toast from "react-hot-toast";

const useResponseAll = (response) => {
  useEffect(() => {
    if (response.isError) {
      toast.custom((t) => (
        <CustomAlert
          t={t}
          type="error"
          data={`Bir hata oluştu ${response.error.data.message ?? ""}`}
        />
      ));
    }
  }, [response.isError, response.error]);

  useEffect(() => {
    if (response.isSuccess) {
      toast.custom((t) => (
        <CustomAlert t={t} type="success" data={`İşlem Başarılı`} />
      ));
    }
  }, [response.isSuccess]);
};

export default useResponseAll;
